import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Divider
} from '@mui/material';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import FormatAmountWithDollar from '../../../../../HbtPortfolioManagement/utils/FormatAmountWithDollar';
import type { PortfolioPoolBreakdown, MasterPoolPremiumsAndTaxes } from '../../types';
import styles from './styles.module.scss';

type Props = {
  selectedDetails: PortfolioPoolBreakdown | MasterPoolPremiumsAndTaxes;
};

const HbtMasterPoolPreimumsBreakdownTable: React.FC<Props> = ({ selectedDetails }) => {
  const { t } = useTranslation('HbtMasterPool');
  const { language } = i18n;
  return (
    <Box className={styles.premiumsAndTaxesFlyoutTable}>
      <TableContainer className={styles.premiumsAndTaxesFlyoutTableContainer}>
        <Table>
          <TableHead>
            <TableCell className={styles.textAlignRight}></TableCell>
            <TableCell
              className={`${styles.premiumsAndTaxesFlyoutTableBoldFont} ${styles.textAlignRight} ${styles.tableHeaderDivider}`}
            >
              {t('PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Header-Due')}
            </TableCell>
            <TableCell
              className={`${styles.premiumsAndTaxesFlyoutTableBoldFont} ${styles.textAlignRight} ${styles.tableHeaderDivider}`}
            >
              {t('PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Header-Received')}
            </TableCell>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={styles.premiumsAndTaxesFlyoutTableBoldFont}>
                {t(
                  'PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Calc-Premium-Amount'
                )}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.premiumAmountDue, language, true)}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.premiumAmountReceived, language, true)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.premiumsAndTaxesFlyoutTableBoldFont}>
                {t(
                  'PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Calc-Taxes-Amount'
                )}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxAmountDue, language, true)}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxAmountReceived, language, true)}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                backgroundColor: '#F7F8F9',
                boxShadow: '0px -4px 6px -4px rgba(0, 0, 0, 0.2)'
              }}
            >
              <TableCell sx={{ pl: 4 }} className={styles.premiumsAndTaxesFlyoutTableTaxBoldFont}>
                {t(
                  'PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Ontario-Tax'
                )}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxOntarioAmountDue, language, true)}
              </TableCell>
              <TableCell
                align="right"
                rowSpan={4}
                sx={{
                  verticalAlign: 'middle'
                }}
              >
                {FormatAmountWithDollar(+selectedDetails.taxAmountReceived, language, true)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.backgroundColorGrey}>
              <TableCell sx={{ pl: 4 }} className={styles.premiumsAndTaxesFlyoutTableTaxBoldFont}>
                {t('PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Quebec-Tax')}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxQuebecAmountDue, language, true)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.backgroundColorGrey}>
              <TableCell sx={{ pl: 4 }} className={styles.premiumsAndTaxesFlyoutTableTaxBoldFont}>
                {t(
                  'PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Manitoba-Tax'
                )}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxManitobaAmountDue, language, true)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.backgroundColorGrey}>
              <TableCell sx={{ pl: 4 }} className={styles.premiumsAndTaxesFlyoutTableTaxBoldFont}>
                {t(
                  'PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Saskatchewan-Tax'
                )}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.taxSaskatchewanAmountDue, language, true)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.premiumsAndTaxesFlyoutTableBoldFont}>
                {t('PI-Master-Pool-Premiums-Taxes-Flyout-Calculation-Details-Table-Row-Total')}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.totalAmountDue, language, true)}
              </TableCell>
              <TableCell className={styles.textAlignRight}>
                {FormatAmountWithDollar(+selectedDetails.totalAmountReceived, language, true)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default HbtMasterPoolPreimumsBreakdownTable;
